import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { BookOpen, Calendar } from "lucide-react";

const formatLong = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
  } catch { return iso; }
};

export default function DailyDevotional() {
  const [dev, setDev] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/devotionals/active")
      .then((r) => setDev(r.data))
      .catch(() => setDev(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading || !dev) return null;

  return (
    <section
      data-testid="daily-devotional"
      className="bg-white rounded-2xl border-2 border-[#D1C9C1] shadow-sm overflow-hidden"
    >
      <div className="bg-[#2C5545] text-white px-5 py-3 flex items-center gap-2">
        <span className="text-xl">🙏</span>
        <h2 className="font-serif text-lg sm:text-xl font-bold">Mensaje Diario del Pastor</h2>
      </div>
      <div className="p-6 sm:p-7">
        <h3 className="font-serif text-2xl font-bold text-[#1A1818] mb-1">{dev.title}</h3>
        <p className="text-sm font-semibold text-[#8A3A33] mb-4">Pastor {dev.pastor_name}</p>

        <div className="flex items-center gap-2 mb-3">
          <BookOpen className="w-4 h-4 text-[#2C5545]" />
          <span className="font-serif italic text-base text-[#2C5545] font-semibold">📖 {dev.scripture}</span>
        </div>

        <p className="text-base sm:text-lg text-[#4A4646] leading-relaxed whitespace-pre-wrap mb-4">
          {dev.message}
        </p>

        <div className="flex items-center gap-2 text-sm text-[#4A4646] border-t border-[#D1C9C1] pt-3">
          <Calendar className="w-4 h-4" />
          <span>📅 {formatLong(dev.publish_at)}</span>
        </div>
      </div>
    </section>
  );
}
